export class LoadingIndicator {
  create = false;
  update = false;
  remove = false;
  page = false;
  item = false;
  count = false;
  fetch = false;
  patch = false;
}

export type LoadingType =
  | 'create'
  | 'update'
  | 'remove'
  | 'page'
  | 'item'
  | 'count'
  | 'fetch'
  | 'patch';
